import { render } from "./AssessmentComplete.vue?vue&type=template&id=73c23f7c&scoped=true"
import script from "./AssessmentComplete.vue?vue&type=script&lang=js"
export * from "./AssessmentComplete.vue?vue&type=script&lang=js"

import "./AssessmentComplete.vue?vue&type=style&index=0&id=73c23f7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c23f7c"]])

export default __exports__